import { render, staticRenderFns } from "./session-expired.vue?vue&type=template&id=07b01112&lang=pug&"
import script from "./session-expired.vue?vue&type=script&lang=js&"
export * from "./session-expired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports